
/**
 * 스트리밍 상태
 */
export type StreamingInfoResponseStatus = typeof StreamingInfoResponseStatus[keyof typeof StreamingInfoResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StreamingInfoResponseStatus = {
  ready: 'ready',
  processing: 'processing',
  error: 'error',
} as const;
